

export const PAN_INDIA_FORM_GET_REQUEST = 'PAN_INDIA_FORM_GET_REQUEST';
export const PAN_INDIA_FORM_GET_SUCCESS = 'PAN_INDIA_FORM_GET_SUCCESS';
export const PAN_INDIA_FORM_GET_FAILURE = 'PAN_INDIA_FORM_GET_FAILURE';


export const UPLOAD_EMPLOYEE_MASTER_REQUEST = 'UPLOAD_EMPLOYEE_MASTER_REQUEST';
export const UPLOAD_EMPLOYEE_MASTER_SUCCESS = 'UPLOAD_EMPLOYEE_MASTER_SUCCESS';
export const UPLOAD_EMPLOYEE_MASTER_FAILURE = 'UPLOAD_EMPLOYEE_MASTER_FAILURE';

export const UPLOAD_EMPLOYEE_DYNAMIC_UPDATE_REQUEST = 'UPLOAD_EMPLOYEE_DYNAMIC_UPDATE_REQUEST';
export const UPLOAD_EMPLOYEE_DYNAMIC_UPDATE_SUCCESS = 'UPLOAD_EMPLOYEE_DYNAMIC_UPDATE_SUCCESS';
export const UPLOAD_EMPLOYEE_DYNAMIC_UPDATE_FAILURE = 'UPLOAD_EMPLOYEE_DYNAMIC_UPDATE_FAILURE';

export const GET_EMPLOYEES_REQUEST = 'GET_EMPLOYEES_REQUEST';
export const GET_EMPLOYEES_SUCCESS = 'GET_EMPLOYEES_SUCCESS';
export const GET_EMPLOYEES_FAILURE = 'GET_EMPLOYEES_FAILURE';


export const UPDATE_EMPLOYEES_REQUEST = 'UPDATE_EMPLOYEES_REQUEST';
export const UPDATE_EMPLOYEES_SUCCESS = 'UPDATE_EMPLOYEES_SUCCESS';
export const UPDATE_EMPLOYEES_FAILURE = 'UPDATE_EMPLOYEES_FAILURE';

export const DELETE_EMPLOYEES_REQUEST = 'DELETE_EMPLOYEES_REQUEST';
export const DELETE_EMPLOYEES_SUCCESS = 'DELETE_EMPLOYEES_SUCCESS';
export const DELETE_EMPLOYEES_FAILURE = 'DELETE_EMPLOYEES_FAILURE';


export const DELETE_SINGLE_ATTENDANCE_REQUEST = 'DELETE_SINGLE_ATTENDANCE_REQUEST';
export const DELETE_SINGLE_ATTENDANCE_SUCCESS = 'DELETE_SINGLE_ATTENDANCE_SUCCESS';
export const DELETE_SINGLE_ATTENDANCE_FAILURE = 'DELETE_SINGLE_ATTENDANCE_FAILURE';

export const MULTIPLE_DELETE_ATTENDANCE_REQUEST = 'MULTIDELETE_ATTENDANCE_REQUEST';
export const MULTIPLE_DELETE_ATTENDANCE_SUCCESS = 'MULTIDELETE_ATTENDANCE_SUCCESS';
export const MULTIPLE_DELETE_ATTENDANCE_FAILURE = 'MULTIDELETE_ATTENDANCE_FAILURE';


export const MULTIDELETE_EMPLOYEES_REQUEST = 'MULTIDELETE_EMPLOYEES_REQUEST';
export const MULTIDELETE_EMPLOYEES_SUCCESS = 'MULTIDELETE_EMPLOYEES_SUCCESS';
export const MULTIDELETE_EMPLOYEES_FAILURE = 'MULTIDELETE_EMPLOYEES_FAILURE';

export const GET_SALARY_REGISTER_REQUEST = 'GET_SALARY_REGISTER_REQUEST';
export const GET_SALARY_REGISTER_SUCCESS = 'GET_SALARY_REGISTER_SUCCESS';
export const GET_SALARY_REGISTER_FAILURE = 'GET_SALARY_REGISTER_FAILURE';

export const REGENERATE_ATTENDANCE_REGISTER_REQUEST = 'REGENERATE_ATTENDANCE_REGISTER_REQUEST';
export const REGENERATE_ATTENDANCE_REGISTER_SUCCESS = 'REGENERATE_ATTENDANCE_REGISTER_SUCCESS';
export const REGENERATE_ATTENDANCE_REGISTER_FAILURE = 'REGENERATE_ATTENDANCE_REGISTER_FAILURE';

export const UPLOAD_SALARY_REGISTER_REQUEST = 'UPLOAD_SALARY_REGISTER_REQUEST';
export const UPLOAD_SALARY_REGISTER_SUCCESS = 'UPLOAD_SALARY_REGISTER_SUCCESS';
export const UPLOAD_SALARY_REGISTER_FAILURE = 'UPLOAD_SALARY_REGISTER_FAILURE';

export const UPDATE_SALARY_REGISTER_REQUEST = 'UPDATE_SALARY_REGISTER_REQUEST';
export const UPDATE_SALARY_REGISTER_SUCCESS = 'UPDATE_SALARY_REGISTER_SUCCESS';
export const UPDATE_SALARY_REGISTER_FAILURE = 'UPDATE_SALARY_REGISTER_FAILURE';

export const DELETE_SALARY_REGISTER_REQUEST = 'DELETE_SALARY_REGISTER_REQUEST';
export const DELETE_SALARY_REGISTER_SUCCESS = 'DELETE_SALARY_REGISTER_SUCCESS';
export const DELETE_SALARY_REGISTER_FAILURE = 'DELETE_SALARY_REGISTER_FAILURE';

export const MULTI_DELETE_SALARY_REGISTER_REQUEST = 'MULTI_DELETE_SALARY_REGISTER_REQUEST';
export const MULTI_DELETE_SALARY_REGISTER_SUCCESS = 'MULTI_DELETE_SALARY_REGISTER_SUCCESS';
export const MULTI_DELETE_SALARY_REGISTER_FAILURE = 'MULTI_DELETE_SALARY_REGISTER_FAILURE';

export const GET_CTC_MASTER_REQUEST = 'GET_CTC_MASTER_REQUEST';
export const GET_CTC_MASTER_SUCCESS = 'GET_CTC_MASTER_SUCCESS';
export const GET_CTC_MASTER_FAILURE = 'GET_CTC_MASTER_FAILURE';

export const UPLOAD_CTC_MASTER_REQUEST = 'UPLOAD_CTC_MASTER_REQUEST';
export const UPLOAD_CTC_MASTER_SUCCESS = 'UPLOAD_CTC_MASTER_SUCCESS';
export const UPLOAD_CTC_MASTER_FAILURE = 'UPLOAD_CTC_MASTER_FAILURE';

export const UPDATE_CTC_MASTER_REQUEST = 'UPDATE_CTC_MASTER_REQUEST';
export const UPDATE_CTC_MASTER_SUCCESS = 'UPDATE_CTC_MASTER_SUCCESS';
export const UPDATE_CTC_MASTER_FAILURE = 'UPDATE_CTC_MASTER_FAILURE';

export const DELETE_CTC_MASTER_REQUEST = 'DELETE_CTC_MASTER_REQUEST';
export const DELETE_CTC_MASTER_SUCCESS = 'DELETE_CTC_MASTER_SUCCESS';
export const DELETE_CTC_MASTER_FAILURE = 'DELETE_CTC_MASTER_FAILURE';

export const MULTI_DELETE_CTC_MASTER_REQUEST = 'MULTI_DELETE_CTC_MASTER_REQUEST';
export const MULTI_DELETE_CTC_MASTER_SUCCESS = 'MULTI_DELETE_CTC_MASTER_SUCCESS';
export const MULTI_DELETE_CTC_MASTER_FAILURE = 'MULTI_DELETE_CTC_MASTER_FAILURE';

export const CREATE_GENERATE_FORM_REQUEST = 'CREATE_GENERATE_FORM_REQUEST';
export const CREATE_GENERATE_FORM_SUCCESS = 'CREATE_GENERATE_FORM_SUCCESS';
export const CREATE_GENERATE_FORM_FAILURE = 'CREATE_GENERATE_FORM_FAILURE';

export const UPLOAD_GENERATED_FORM_REQUEST = 'UPLOAD_GENERATED_FORM_REQUEST';
export const UPLOAD_GENERATED_FORM_SUCCESS = 'UPLOAD_GENERATED_FORM_SUCCESS';
export const UPLOAD_GENERATED_FORM_FAILURE = 'UPLOAD_GENERATED_FORM_FAILURE';

export const GET_GENERATED_FORM_REQUEST = 'GET_GENERATED_FORM_REQUEST';
export const GET_GENERATED_FORM_SUCCESS = 'GET_GENERATED_FORM_SUCCESS';
export const GET_GENERATED_FORM_FAILURE = 'GET_GENERATED_FORM_FAILURE';

export const UPDATE_GENERATED_FORM_REQUEST = 'UPDATE_GENERATED_FORM_REQUEST';
export const UPDATE_GENERATED_FORM_SUCCESS = 'UPDATE_GENERATED_FORM_SUCCESS';
export const UPDATE_GENERATED_FORM_FAILURE = 'UPDATE_GENERATED_FORM_FAILURE';

export const DELETE_GENERATED_FORM_REQUEST = 'DELETE_GENERATED_FORM_REQUEST';
export const DELETE_GENERATED_FORM_SUCCESS = 'DELETE_GENERATED_FORM_SUCCESS';
export const DELETE_GENERATED_FORM_FAILURE = 'DELETE_GENERATED_FORM_FAILURE';



export const GET_LEAVE_MASTER_REQUEST = 'GET_LEAVE_MASTER_REQUEST';
export const GET_LEAVE_MASTER_SUCCESS = 'GET_LEAVE_MASTER_SUCCESS';
export const GET_LEAVE_MASTER_FAILURE = 'GET_LEAVE_MASTER_FAILURE';

export const CREATE_LEAVE_MASTER_REQUEST = 'UPLOAD_LEAVE_MASTER_REQUEST';
export const CREATE_LEAVE_MASTER_SUCCESS = 'UPLOAD_LEAVE_MASTER_SUCCESS';
export const CREATE_LEAVE_MASTER_FAILURE = 'UPLOAD_LEAVE_MASTER_FAILURE';

export const UPDATE_LEAVE_MASTER_REQUEST = 'UPDATE_LEAVE_MASTER_REQUEST';
export const UPDATE_LEAVE_MASTER_SUCCESS = 'UPDATE_LEAVE_MASTER_SUCCESS';
export const UPDATE_LEAVE_MASTER_FAILURE = 'UPDATE_LEAVE_MASTER_FAILURE';

export const DELETE_LEAVE_MASTER_REQUEST = 'DELETE_LEAVE_MASTER_REQUEST';
export const DELETE_LEAVE_MASTER_SUCCESS = 'DELETE_LEAVE_MASTER_SUCCESS';
export const DELETE_LEAVE_MASTER_FAILURE = 'DELETE_CTC_MASTER_FAILURE';

export const UPLOAD_LEAVE_MASTER_REQUEST = 'UPLOAD_LEAVE_MASTER_REQUEST';
export const UPLOAD_LEAVE_MASTER_SUCCESS = 'UPLOAD_LEAVE_MASTER_SUCCESS';
export const UPLOAD_LEAVE_MASTER_FAILURE = 'UPLOAD_LEAVE_MASTER_FAILURE';

export const MULTIDELETE_LEAVE_MASTER_REQUEST = 'MULTIDELETE_LEAVE_MASTER_REQUEST';
export const MULTIDELETE_LEAVE_MASTER_SUCCESS = 'MULTIDELETE_LEAVE_MASTER_SUCCESS';
export const MULTIDELETE_LEAVE_MASTER_FAILURE = 'MULTIDELETE_CTC_MASTER_FAILURE';


export const GET_LEAVE_REGISTER_REQUEST = 'GET_LEAVE_REGISTER_REQUEST';
export const GET_LEAVE_REGISTER_SUCCESS = 'GET_LEAVE_REGISTER_SUCCESS';
export const GET_LEAVE_REGISTER_FAILURE = 'GET_LEAVE_REGISTER_FAILURE';

export const UPDATE_LEAVE_REGISTER_REQUEST = 'UPDATE_LEAVE_REGISTER_REQUEST';
export const UPDATE_LEAVE_REGISTER_SUCCESS = 'UPDATE_LEAVE_REGISTER_SUCCESS';
export const UPDATE_LEAVE_REGISTER_FAILURE = 'UPDATE_LEAVE_REGISTER_FAILURE';

export const DELETE_LEAVE_REGISTER_REQUEST = 'DELETE_LEAVE_REGISTER_REQUEST';
export const DELETE_LEAVE_REGISTER_SUCCESS = 'DELETE_LEAVE_REGISTER_SUCCESS';
export const DELETE_LEAVE_REGISTER_FAILURE = 'DELETE_CTC_REGISTER_FAILURE';

export const UPLOAD_LEAVE_REGISTER_REQUEST = 'UPLOAD_LEAVE_REGISTER_REQUEST';
export const UPLOAD_LEAVE_REGISTER_SUCCESS = 'UPLOAD_LEAVE_REGISTER_SUCCESS';
export const UPLOAD_LEAVE_REGISTER_FAILURE = 'UPLOAD_LEAVE_REGISTER_FAILURE';

export const MULTIDELETE_LEAVE_REGISTER_REQUEST = 'MULTIDELETE_LEAVE_REGISTER_REQUEST';
export const MULTIDELETE_LEAVE_REGISTER_SUCCESS = 'MULTIDELETE_LEAVE_REGISTER_SUCCESS';
export const MULTIDELETE_LEAVE_REGISTER_FAILURE = 'MULTIDELETE_CTC_REGISTER_FAILURE';


export const GET_ATTENDANCE_REQUEST = 'GET_ATTENDANCE_REQUEST';
export const GET_ATTENDANCE_SUCCESS = 'GET_ATTENDANCE_SUCCESS';
export const GET_ATTENDANCE_FAILURE = 'GET_ATTENDANCE_FAILURE';

export const UPDATE_ATTENDANCE_REQUEST = 'UPDATE_ATTENDANCE_REQUEST';
export const UPDATE_ATTENDANCE_SUCCESS = 'UPDATE_ATTENDANCE_SUCCESS';
export const UPDATE_ATTENDANCE_FAILURE = 'UPDATE_ATTENDANCE_FAILURE';

export const DELETE_ATTENDANCE_REQUEST = 'DELETE_ATTENDANCE_REQUEST';
export const DELETE_ATTENDANCE_SUCCESS = 'DELETE_ATTENDANCE_SUCCESS';
export const DELETE_ATTENDANCE_FAILURE = 'DELETE_ATTENDANCE_FAILURE';

export const MULTIDELETE_ATTENDANCE_REQUEST = 'MULTIDELETE_ATTENDANCE_REQUEST';
export const MULTIDELETE_ATTENDANCE_SUCCESS = 'MULTIDELETE_ATTENDANCE_SUCCESS';
export const MULTIDELETE_ATTENDANCE_FAILURE = 'MULTIDELETE_ATTENDANCE_FAILURE';

export const UPLOAD_ATTENDANCE_OVERRIDE_REQUEST = 'UPLOAD_ATTENDANCE_OVERRIDE_REQUEST';
export const UPLOAD_ATTENDANCE_OVERRIDE_SUCCESS = 'UPLOAD_ATTENDANCE_OVERRIDE_SUCCESS';
export const UPLOAD_ATTENDANCE_OVERRIDE_FAILURE = 'UPLOAD_ATTENDANCE_OVERRIDE_FAILURE';

export const GET_ATTENDANCE_OVERRIDE_REQUEST = 'GET_ATTENDANCE_OVERRIDE_REQUEST';
export const GET_ATTENDANCE_OVERRIDE_SUCCESS = 'GET_ATTENDANCE_OVERRIDE_SUCCESS';
export const GET_ATTENDANCE_OVERRIDE_FAILURE = 'GET_ATTENDANCE_OVERRIDE_FAILURE';


export const MULTIDELETE_ATTENDANCE_OVERRIDE_REQUEST = 'MULTIDELETE_ATTENDANCE_OVERRIDE_REQUEST';
export const MULTIDELETE_ATTENDANCE_OVERRIDE_SUCCESS = 'MULTIDELETE_ATTENDANCE_OVERRIDE_SUCCESS';
export const MULTIDELETE_ATTENDANCE_OVERRIDE_FAILURE = 'MULTIDELETE_ATTENDANCE_OVERRIDE_FAILURE';

export const DOWNLOAD_ATTENDANCE_REQUEST = 'DOWNLOAD_ATTENDANCE_REQUEST';
export const DOWNLOAD_ATTENDANCE_SUCCESS = 'DOWNLOAD_ATTENDANCE_SUCCESS';
export const DOWNLOAD_ATTENDANCE_FAILURE = 'DOWNLOAD_ATTENDANCE_FAILURE';

export const DOWNLOAD_ALL_ATTENDANCE_REQUEST = 'DOWNLOAD_ALL_ATTENDANCE_REQUEST';
export const DOWNLOAD_ALL_ATTENDANCE_SUCCESS = 'DOWNLOAD_ALL_ATTENDANCE_SUCCESS';
export const DOWNLOAD_ALL_ATTENDANCE_FAILURE = 'DOWNLOAD_ALL_ATTENDANCE_FAILURE';



export const GET_MATERNITY_BENEFITS_REQUEST = 'GET_MATERNITY_BENEFITS_REQUEST';
export const GET_MATERNITY_BENEFITS_SUCCESS = 'GET_MATERNITY_BENEFITS_SUCCESS';
export const GET_MATERNITY_BENEFITS_FAILURE = 'GET_MATERNITY_BENEFITS_FAILURE';

export const UPDATE_MATERNITY_BENEFITS_REQUEST = 'UPDATE_MATERNITY_BENEFITS_REQUEST';
export const UPDATE_MATERNITY_BENEFITS_SUCCESS = 'UPDATE_MATERNITY_BENEFITS_SUCCESS';
export const UPDATE_MATERNITY_BENEFITS_FAILURE = 'UPDATE_MATERNITY_BENEFITS_FAILURE';

export const DELETE_MATERNITY_BENEFITS_REQUEST = 'DELETE_MATERNITY_BENEFITS_REQUEST';
export const DELETE_MATERNITY_BENEFITS_SUCCESS = 'DELETE_MATERNITY_BENEFITS_SUCCESS';
export const DELETE_MATERNITY_BENEFITS_FAILURE = 'DELETE_CTC_REGISTER_FAILURE';

export const UPLOAD_MATERNITY_BENEFITS_REQUEST = 'UPLOAD_MATERNITY_BENEFITS_REQUEST';
export const UPLOAD_MATERNITY_BENEFITS_SUCCESS = 'UPLOAD_MATERNITY_BENEFITS_SUCCESS';
export const UPLOAD_MATERNITY_BENEFITS_FAILURE = 'UPLOAD_MATERNITY_BENEFITS_FAILURE';

export const MULTIDELETE_MATERNITY_BENEFITS_REQUEST = 'MULTIDELETE_MATERNITY_BENEFITS_REQUEST';
export const MULTIDELETE_MATERNITY_BENEFITS_SUCCESS = 'MULTIDELETE_MATERNITY_BENEFITS_SUCCESS';
export const MULTIDELETE_MATERNITY_BENEFITS_FAILURE = 'MATERNITY_BENEFITS_FAILURE';

export const GET_FORM_REQUEST = 'GET_FORM_REQUEST';
export const GET_FORM_SUCCESS = 'GET_FORM_SUCCESS';
export const GET_FORM_FAILURE = 'GET_FORM_FAILURE';

export const GET_getInputMatrixActivities_REQUEST = 'GET_getInputMatrixActivities_REQUEST';
export const GET_getInputMatrixActivities_SUCCESS = 'GET_getInputMatrixActivities_SUCCESS';
export const GET_getInputMatrixActivities_FAILURE = 'GET_getInputMatrixActivities_FAILURE';

export const GET_SALARY_ADVANCES_REQUEST = 'GET_SALARY_ADVANCES_REQUEST';
export const GET_SALARY_ADVANCES_SUCCESS = 'GET_SALARY_ADVANCES_SUCCESS';
export const GET_SALARY_ADVANCES_FAILURE = 'GET_SALARY_ADVANCES_FAILURE';

export const UPDATE_SALARY_ADVANCES_REQUEST = 'UPDATE_SALARY_ADVANCES_REQUEST';
export const UPDATE_SALARY_ADVANCES_SUCCESS = 'UPDATE_SALARY_ADVANCES_SUCCESS';
export const UPDATE_SALARY_ADVANCES_FAILURE = 'UPDATE_SALARY_ADVANCES_FAILURE';

export const DELETE_SALARY_ADVANCES_REQUEST = 'DELETE_SALARY_ADVANCES_REQUEST';
export const DELETE_SALARY_ADVANCES_SUCCESS = 'DELETE_SALARY_ADVANCES_SUCCESS';
export const DELETE_SALARY_ADVANCES_FAILURE = 'DELETE_CTC_REGISTER_FAILURE';

export const UPLOAD_SALARY_ADVANCES_REQUEST = 'UPLOAD_SALARY_ADVANCES_REQUEST';
export const UPLOAD_SALARY_ADVANCES_SUCCESS = 'UPLOAD_SALARY_ADVANCES_SUCCESS';
export const UPLOAD_SALARY_ADVANCES_FAILURE = 'UPLOAD_SALARY_ADVANCES_FAILURE';

export const MULTIDELETE_SALARY_ADVANCES_REQUEST = 'MULTIDELETE_SALARY_ADVANCES_REQUEST';
export const MULTIDELETE_SALARY_ADVANCES_SUCCESS = 'MULTIDELETE_SALARY_ADVANCES_SUCCESS';
export const MULTIDELETE_SALARY_ADVANCES_FAILURE = 'SALARY_ADVANCES_FAILURE';

export const GET_OTHER_INPUTS_REQUEST = 'GET_OTHER_INPUTS_REQUEST';
export const GET_OTHER_INPUTS_SUCCESS = 'GET_OTHER_INPUTS_SUCCESS';
export const GET_OTHER_INPUTS_FAILURE = 'GET_OTHER_INPUTS_FAILURE';

export const UPDATE_OTHER_INPUTS_REQUEST = 'UPDATE_OTHER_INPUTS_REQUEST';
export const UPDATE_OTHER_INPUTS_SUCCESS = 'UPDATE_OTHER_INPUTS_SUCCESS';
export const UPDATE_OTHER_INPUTS_FAILURE = 'UPDATE_OTHER_INPUTS_FAILURE';

export const DELETE_OTHER_INPUTS_REQUEST = 'DELETE_OTHER_INPUTS_REQUEST';
export const DELETE_OTHER_INPUTS_SUCCESS = 'DELETE_OTHER_INPUTS_SUCCESS';
export const DELETE_OTHER_INPUTS_FAILURE = 'DELETE_OTHER_INPUTS_FAILURE';

export const UPLOAD_OTHER_INPUTS_REQUEST = 'UPLOAD_OTHER_INPUTS_REQUEST';
export const UPLOAD_OTHER_INPUTS_SUCCESS = 'UPLOAD_OTHER_INPUTS_SUCCESS';
export const UPLOAD_OTHER_INPUTS_FAILURE = 'UPLOAD_OTHER_INPUTS_FAILURE';

export const MULTIDELETE_OTHER_INPUTS_REQUEST = 'MULTIDELETE_OTHER_INPUTS_REQUEST';
export const MULTIDELETE_OTHER_INPUTS_SUCCESS = 'MULTIDELETE_OTHER_INPUTS_SUCCESS';
export const MULTIDELETE_OTHER_INPUTS_FAILURE = 'MULTIDELETE_OTHER_INPUTS_FAILURE';



export const GET_TN_FORM_VI_REQUEST = 'GET_TN_FORM_VI_REQUEST';
export const GET_TN_FORM_VI_SUCCESS = 'GET_TN_FORM_VI_SUCCESS';
export const GET_TN_FORM_VI_FAILURE = 'GET_TN_FORM_VI_FAILURE';

export const UPDATE_TN_FORM_VI_REQUEST = 'UPDATE_TN_FORM_VI_REQUEST';
export const UPDATE_TN_FORM_VI_SUCCESS = 'UPDATE_TN_FORM_VI_SUCCESS';
export const UPDATE_TN_FORM_VI_FAILURE = 'UPDATE_TN_FORM_VI_FAILURE';

export const DELETE_TN_FORM_VI_REQUEST = 'DELETE_TN_FORM_VI_REQUEST';
export const DELETE_TN_FORM_VI_SUCCESS = 'DELETE_TN_FORM_VI_SUCCESS';
export const DELETE_TN_FORM_VI_FAILURE = 'DELETE_CTC_REGISTER_FAILURE';

export const UPLOAD_TN_FORM_VI_REQUEST = 'UPLOAD_TN_FORM_VI_REQUEST';
export const UPLOAD_TN_FORM_VI_SUCCESS = 'UPLOAD_TN_FORM_VI_SUCCESS';
export const UPLOAD_TN_FORM_VI_FAILURE = 'UPLOAD_TN_FORM_VI_FAILURE';

export const MULTIDELETE_TN_FORM_VI_REQUEST = 'MULTIDELETE_TN_FORM_VI_REQUEST';
export const MULTIDELETE_TN_FORM_VI_SUCCESS = 'MULTIDELETE_TN_FORM_VI_SUCCESS';
export const MULTIDELETE_TN_FORM_VI_FAILURE = 'MULTIDELETE_TN_FORM_VI_FAILURE';


export const GET_EMP_SEPARATION_REQUEST = 'GET_EMP_SEPARATION_REQUEST';
export const GET_EMP_SEPARATION_SUCCESS = 'GET_EMP_SEPARATION_SUCCESS';
export const GET_EMP_SEPARATION_FAILURE = 'GET_EMP_SEPARATION_FAILURE';

export const UPDATE_EMP_SEPARATION_REQUEST = 'UPDATE_EMP_SEPARATION_REQUEST';
export const UPDATE_EMP_SEPARATION_SUCCESS = 'UPDATE_EMP_SEPARATION_SUCCESS';
export const UPDATE_EMP_SEPARATION_FAILURE = 'UPDATE_EMP_SEPARATION_FAILURE';

export const DELETE_EMP_SEPARATION_REQUEST = 'DELETE_EMP_SEPARATION_REQUEST';
export const DELETE_EMP_SEPARATION_SUCCESS = 'DELETE_EMP_SEPARATION_SUCCESS';
export const DELETE_EMP_SEPARATION_FAILURE = 'DELETE_CTC_REGISTER_FAILURE';

export const UPLOAD_EMP_SEPARATION_REQUEST = 'UPLOAD_EMP_SEPARATION_REQUEST';
export const UPLOAD_EMP_SEPARATION_SUCCESS = 'UPLOAD_EMP_SEPARATION_SUCCESS';
export const UPLOAD_EMP_SEPARATION_FAILURE = 'UPLOAD_EMP_SEPARATION_FAILURE';

export const MULTIDELETE_EMP_SEPARATION_REQUEST = 'MULTIDELETE_EMP_SEPARATION_REQUEST';
export const MULTIDELETE_EMP_SEPARATION_SUCCESS = 'MULTIDELETE_EMP_SEPARATION_SUCCESS';
export const MULTIDELETE_EMP_SEPARATION_FAILURE = 'MULTIDELETE_EMP_SEPARATION_FAILURE';

export const GET_LEAVE_OPENING_BALANCE_REQUEST = 'GET_LEAVE_OPENING_BALANCE_REQUEST';
export const GET_LEAVE_OPENING_BALANCE_SUCCESS = 'GET_LEAVE_OPENING_BALANCE_SUCCESS';
export const GET_LEAVE_OPENING_BALANCE_FAILURE = 'GET_LEAVE_OPENING_BALANCE_FAILURE';

export const CREATE_LEAVE_OPENING_BALANCE_REQUEST = 'UPLOAD_LEAVE_OPENING_BALANCE_REQUEST';
export const CREATE_LEAVE_OPENING_BALANCE_SUCCESS = 'UPLOAD_LEAVE_OPENING_BALANCE_SUCCESS';
export const CREATE_LEAVE_OPENING_BALANCE_FAILURE = 'UPLOAD_LEAVE_OPENING_BALANCE_FAILURE';

export const UPDATE_LEAVE_OPENING_BALANCE_REQUEST = 'UPDATE_LEAVE_OPENING_BALANCE_REQUEST';
export const UPDATE_LEAVE_OPENING_BALANCE_SUCCESS = 'UPDATE_LEAVE_OPENING_BALANCE_SUCCESS';
export const UPDATE_LEAVE_OPENING_BALANCE_FAILURE = 'UPDATE_LEAVE_OPENING_BALANCE_FAILURE';

export const DELETE_LEAVE_OPENING_BALANCE_REQUEST = 'DELETE_LEAVE_OPENING_BALANCE_REQUEST';
export const DELETE_LEAVE_OPENING_BALANCE_SUCCESS = 'DELETE_LEAVE_OPENING_BALANCE_SUCCESS';
export const DELETE_LEAVE_OPENING_BALANCE_FAILURE = 'DELETE_CTC_MASTER_FAILURE';

export const UPLOAD_LEAVE_OPENING_BALANCE_REQUEST = 'UPLOAD_LEAVE_OPENING_BALANCE_REQUEST';
export const UPLOAD_LEAVE_OPENING_BALANCE_SUCCESS = 'UPLOAD_LEAVE_OPENING_BALANCE_SUCCESS';
export const UPLOAD_LEAVE_OPENING_BALANCE_FAILURE = 'UPLOAD_LEAVE_OPENING_BALANCE_FAILURE';

export const MULTIDELETE_LEAVE_OPENING_BALANCE_REQUEST = 'MULTIDELETE_LEAVE_OPENING_BALANCE_REQUEST';
export const MULTIDELETE_LEAVE_OPENING_BALANCE_SUCCESS = 'MULTIDELETE_LEAVE_OPENING_BALANCE_SUCCESS';
export const MULTIDELETE_LEAVE_OPENING_BALANCE_FAILURE = 'MULTIDELETE_CTC_MASTER_FAILURE';

export const GET_ALL_EMPLOYEE_REPORTS_REQUEST = 'GET_ALL_EMPLOYEE_REPORTS_REQUEST';
export const GET_ALL_EMPLOYEE_REPORTS_SUCCESS = 'GET_ALL_EMPLOYEE_REPORTS_SUCCESS';
export const GET_ALL_EMPLOYEE_REPORTS_FAILURE = 'GET_ALL_EMPLOYEE_REPORTS_FAILURE';

export const GET_ALL_EMPLOYEE_REPORTS_AS_PER_DATE_REQUEST = 'GET_ALL_EMPLOYEE_REPORTS_AS_PER_DATE_REQUEST';
export const GET_ALL_EMPLOYEE_REPORTS_AS_PER_DATE_SUCCESS = 'GET_ALL_EMPLOYEE_REPORTS_AS_PER_DATE_SUCCESS';
export const GET_ALL_EMPLOYEE_REPORTS_AS_PER_DATE_FAILURE = 'GET_ALL_EMPLOYEE_REPORTS_AS_PER_DATE_FAILURE';


export const GET_HEADERS_REQUEST = 'GET_HEADERS_REQUEST';
export const GET_HEADERS_SUCCESS = 'GET_HEADERS_SUCCESS';
export const GET_HEADERS_FAILURE = 'GET_HEADERS_FAILURE';

export const CREATE_HEADERS_REQUEST = 'CREATE_HEADERS_REQUEST';
export const CREATE_HEADERS_SUCCESS = 'CREATE_HEADERS_SUCCESS';
export const CREATE_HEADERS_FAILURE = 'CREATE_HEADERS_FAILURE';

export const UPDATE_HEADERS_REQUEST = 'UPDATE_HEADERS_REQUEST';
export const UPDATE_HEADERS_SUCCESS = 'UPDATE_HEADERS_SUCCESS';
export const UPDATE_HEADERS_FAILURE = 'UPDATE_HEADERS_FAILURE';

export const DELETE_HEADERS_REQUEST = 'DELETE_HEADERS_REQUEST';
export const DELETE_HEADERS_SUCCESS = 'DELETE_HEADERS_SUCCESS';
export const DELETE_HEADERS_FAILURE = 'DELETE_HEADERS_FAILURE';

export const MULTIDELETE_UNIT_REQUEST = 'MULTIDELETE_UNIT_REQUEST';
export const MULTIDELETE_UNIT_SUCCESS = 'MULTIDELETE_UNIT_SUCCESS';
export const MULTIDELETE_UNIT_FAILURE = 'MULTIDELETE_UNIT_FAILURE';

export const SINGLEADD_UNIT_REQUEST = 'SINGLEADD_UNIT_REQUEST';
export const SINGLEADD_UNIT_SUCCESS = 'SINGLEADD_UNIT_SUCCESS';
export const SINGLEADD_UNIT_FAILURE = 'SINGLEADD_UNIT_FAILURE';

export const GENERATED_FORM_DOWNLOAD_REQUEST = 'GENERATED_FORM_DOWNLOAD_REQUEST';
export const GENERATED_FORM_DOWNLOAD_SUCCESS = 'GENERATED_FORM_DOWNLOAD_SUCCESS';
export const GENERATED_FORM_DOWNLOAD_FAILURE = 'GENERATED_FORM_DOWNLOAD_FAILURE';


export const GET_CONTRACTOR_REQUEST = 'GET_CONTRACTOR_REQUEST';
export const GET_CONTRACTOR_SUCCESS = 'GET_CONTRACTOR_SUCCESS';
export const GET_CONTRACTOR_FAILURE = 'GET_CONTRACTOR_FAILURE';

export const UPDATE_CONTRACTOR_REQUEST = 'UPDATE_CONTRACTOR_REQUEST';
export const UPDATE_CONTRACTOR_SUCCESS = 'UPDATE_CONTRACTOR_SUCCESS';
export const UPDATE_CONTRACTOR_FAILURE = 'UPDATE_CONTRACTOR_FAILURE';

export const DELETE_CONTRACTOR_REQUEST = 'DELETE_CONTRACTOR_REQUEST';
export const DELETE_CONTRACTOR_SUCCESS = 'DELETE_CONTRACTOR_SUCCESS';
export const DELETE_CONTRACTOR_FAILURE = 'DELETE_CTC_REGISTER_FAILURE';

export const UPLOAD_CONTRACTOR_REQUEST = 'UPLOAD_CONTRACTOR_REQUEST';
export const UPLOAD_CONTRACTOR_SUCCESS = 'UPLOAD_CONTRACTOR_SUCCESS';
export const UPLOAD_CONTRACTOR_FAILURE = 'UPLOAD_CONTRACTOR_FAILURE';

export const MULTIDELETE_CONTRACTOR_REQUEST = 'MULTIDELETE_CONTRACTOR_REQUEST';
export const MULTIDELETE_CONTRACTOR_SUCCESS = 'MULTIDELETE_CONTRACTOR_SUCCESS';
export const MULTIDELETE_CONTRACTOR_FAILURE = 'CONTRACTOR_FAILURE';

export const GET_RETURNS_FORMS_REQUEST = 'GET_RETURNS_FORMS_REQUEST';
export const GET_RETURNS_FORMS_SUCCESS = 'GET_RETURNS_FORMS_SUCCESS';
export const GET_RETURNS_FORMS_FAILURE = 'GET_RETURNS_FORMS_FAILURE';


/* Returns (compliance returns master) */
export const GET_RETURN_FORM_REQUEST = 'GET_RETURN_FORM_REQUEST';
export const GET_RETURN_FORM_SUCCESS = 'GET_RETURN_FORM_SUCCESS';
export const GET_RETURN_FORM_FAILURE = 'GET_RETURN_FORM_FAILURE';

export const GET_RETURNSNEW_FORMS_REQUEST = 'GET_RETURNSNEW_FORMS_REQUEST';
export const GET_RETURNSNEW_FORMS_SUCCESS = 'GET_RETURNSNEW_FORMS_SUCCESS';
export const GET_RETURNSNEW_FORMS_FAILURE = 'GET_RETURNSNEW_FORMS_FAILURE';

export const CREATE_RETURNS_FORM_REQUEST = 'CREATE_RETURNS_FORM_REQUEST';
export const CREATE_RETURNS_FORM_SUCCESS = 'CREATE_RETURNS_FORM_SUCCESS';
export const CREATE_RETURNS_FORM_FAILURE = 'CREATE_RETURNS_FORM_FAILURE';

export const UPDATE_RETURNS_FORM_REQUEST = 'UPDATE_RETURNS_FORM_REQUEST';
export const UPDATE_RETURNS_FORM_SUCCESS = 'UPDATE_RETURNS_FORM_SUCCESS';
export const UPDATE_RETURNS_FORM_FAILURE = 'UPDATE_RETURNS_FORM_FAILURE';

export const DELETE_RETURNS_FORM_REQUEST = 'DELETE_RETURNS_FORM_REQUEST';
export const DELETE_RETURNS_FORM_SUCCESS = 'DELETE_RETURNS_FORM_SUCCESS';
export const DELETE_RETURNS_FORM_FAILURE = 'DELETE_RETURNS_FORM_FAILURE';

export const CREATE_GENERATENEW_FORM_REQUEST = 'CREATE_GENERATENEW_FORM_REQUEST';
export const CREATE_GENERATENEW_FORM_SUCCESS = 'CREATE_GENERATENEW_FORM_SUCCESS';
export const CREATE_GENERATENEW_FORM_FAILURE = 'CREATE_GENERATENEW_FORM_FAILURE';

export const GET_RETURN_SELECTED_YEAR_REQUEST = 'GET_RETURN_SELECTED_YEAR_REQUEST';
export const GET_RETURN_SELECTED_YEAR_SUCCESS = 'GET_RETURN_SELECTED_YEAR_SUCCESS';
export const GET_RETURN_SELECTED_YEAR_FAILURE = 'GET_RETURN_SELECTED_YEAR_FAILURE';
